import Header from "../components/Header";
import { AnimatePresence, motion } from "motion/react";
import { opacityVariants, routeVariants } from "../routesVariants";
import {
  Button,
  Select,
  Snackbar,
  Spinner,
  Title,
} from "../uikit";
import Card from "../components/Card";
import { useEffect, useState } from "react";

import SupportButton from "../components/SupportButton";

import { useTranslation } from "react-i18next";
import EmptyGuide from "../components/guides/EmptyGuide";
import { useLocation, useNavigate, useParams } from "react-router";
import { getUserData } from "../utils/Api";
import { DOMAIN } from "../consts";

import AndroidGuide from "../components/guides/simple_guides/openvpn/AndroidGuide";
import IosGuide from "../components/guides/simple_guides/openvpn/IosGuide";
import WindowsGuide from "../components/guides/simple_guides/openvpn/WindowsGuide";
import MacosGuide from "../components/guides/simple_guides/openvpn/MacosGuide";
import LinuxGuide from "../components/guides/simple_guides/openvpn/LinuxGuide";

import AndroidGuideVless from "../components/guides/simple_guides/vless/AndroidGuide";
import IosGuideVless from "../components/guides/simple_guides/vless/IosGuide";
import WindowsGuideVless from "../components/guides/simple_guides/vless/WindowsGuide";
import MacosGuideVless from "../components/guides/simple_guides/vless/MacosGuide";
import LinuxGuideVless from "../components/guides/simple_guides/vless/LinuxGuide";
import { getToken } from "../utils/tokenStorage";

export default function Guide() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const [isLoaded, setIsLoaded] = useState(false);
  const [subscription, setSubscription] = useState(
    location.state?.subscription ?? {}
  );
  const [os, setOs] = useState("android");
  const [protocol, setProtocol] = useState("openvpn");
  const [servers, setServers] = useState([]);
  const { t, _ } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [message, setMessage] = useState("");

  const setOsHandler = (event) => {
    const value = event.target.value;
    changeOs(value);
  };

  const setProtocolHandler = (event) => {
    const value = event.target.value;
    changeProtocol(value);
  };

  const guides = {
    windows: <WindowsGuide subscription={subscription} servers={servers} />,
    android: <AndroidGuide subscription={subscription} servers={servers} />,
    ios: <IosGuide subscription={subscription} servers={servers} />,
    linux: <LinuxGuide subscription={subscription} servers={servers} />,
    macos: <MacosGuide subscription={subscription} servers={servers} />,
    mikrotik: <EmptyGuide subscription={subscription} />,
    xiaomi: <EmptyGuide subscription={subscription} />,
  };

  const guidesVless = {
    windows: (
      <WindowsGuideVless subscription={subscription} servers={servers} />
    ),
    android: (
      <AndroidGuideVless subscription={subscription} servers={servers} />
    ),
    ios: <IosGuideVless subscription={subscription} servers={servers} />,
    linux: <LinuxGuideVless subscription={subscription} servers={servers} />,
    macos: <MacosGuideVless subscription={subscription} servers={servers} />,
    mikrotik: <EmptyGuide subscription={subscription} />,
    xiaomi: <EmptyGuide subscription={subscription} />,
  };

  const gatherData = async () => {
    if (subscription != null && Object.keys(subscription).length) {
      return subscription;
    }

    if (!("login" in params)) {
      return null;
    }

    const [success, result] = await getUserData();
    if (!success) {
      return null;
    }

    // В параметре маршрута приходит логин или subscription_id (deep link из бота)
    const subs = result.subs.filter(
      (x) =>
        x.login === params.login ||
        String(x.id) === String(params.login) ||
        String(x.subscription_id) === String(params.login)
    );
    if (subs.length == 0) {
      return null;
    }

    setSubscription(subs[0]);
    return subs[0];
  };

  const getServers = async (currentSubscription) => {
    const token = getToken();
    if (token == "" || token == null) {
      navigate("/login");
      return false;
    }

    const response = await fetch(
      DOMAIN +
        "/subscriptions/" +
        currentSubscription.id +
        "/servers?purpose=input",
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then((r) => r.json());

    if (!response.success) {
      return false;
    }

    const data = (response.servers || []).map((row) => ({
      ...row,
      hostname: row.domain || row.name,
      request_name: row.name,
      location: row.city,
    }));
    setServers(data);
    return true;
  };

  const prepareData = async () => {
    const currentSubscription = await gatherData();
    if (!currentSubscription) {
      navigate("/account");
      return;
    }

    const hasServers = await getServers(currentSubscription);
    if (!hasServers) {
      navigate("/account");
      return;
    }
    setIsLoaded(true);
  };

  useEffect(() => {
    prepareData();
  }, []);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    try {
      const data = {
        android: "android",
        windows: "windows",
        iphone: "ios",
        ipad: "ios",
      };
      const userAgent = navigator.userAgent.toLowerCase();
      for (const key of Object.keys(data)) {
        if (userAgent.includes(key)) {
          changeOs(data[key]);
          return;
        }
      }
    } catch {}
    changeOs("android");
  }, [isLoaded]);

  const changeOs = (value) => {
    setOs(value);
  };

  const changeProtocol = (value) => {
    setProtocol(value);
  };

  return (
    <motion.div
      className="container background-regular border-padding column-spacing column"
      variants={routeVariants}
      initial="initial"
      animate="final"
      exit="exit"
    >
      <Header isBack={true} backCallback={() => navigate("/account")}>
        <Title level="1" weight="3">
          {t("Setup")}
        </Title>
      </Header>
      {isLoaded ? (
        <>
          <Card>
            <div className="column card">
              <div className="mb-1">
                <Select header={t("Protocol")} onChange={setProtocolHandler}>
                  <option value="openvpn" selected={"openvpn" === os}>
                    OpenVPN
                  </option>
                  <option value="vless" selected={"vless" === os}>
                    VLESS
                  </option>
                </Select>
              </div>
              <div className="mb-1">
                <Select header={t("Operation system")} onChange={setOsHandler}>
                  <option value="android" selected={"android" === os}>
                    Android
                  </option>
                  <option value="ios" selected={"ios" === os}>
                    iOS
                  </option>
                  <option value="windows" selected={"windows" === os}>
                    Windows
                  </option>
                  <option value="linux" selected={"linux" === os}>
                    Linux
                  </option>
                  <option value="macos" selected={"macos" === os}>
                    macOS
                  </option>
                  <option value="mikrotik" selected={"mikrotik" === os}>
                    MikroTik
                  </option>
                  <option value="xiaomi" selected={"xiaomi" === os}>
                    Xiaomi
                  </option>
                </Select>
              </div>
              <AnimatePresence exitBeforeEnter>
                <motion.div
                  key={os + protocol}
                  variants={opacityVariants}
                  initial="initial"
                  animate="final"
                  exit="exit"
                >
                  {protocol === "vless" ? guidesVless[os] : guides[os]}
                </motion.div>
              </AnimatePresence>
              <div className="mb-1"></div>
            </div>
          </Card>
          <Button
            mode="gray"
            size="l"
            onClick={() =>
              navigate(`/account/guide/${subscription.login}/all`, {
                state: { subscription: subscription },
              })
            }
          >
            {t("All guides")}
          </Button>
          <SupportButton />
        </>
      ) : (
        <div className="center full-height">
          <Spinner />
        </div>
      )}
      {showSnackbar && (
        <Snackbar onClose={() => setShowSnackbar(false)}>{t(message)}</Snackbar>
      )}
    </motion.div>
  );
}
